import React, { useEffect, useState } from "react";
import { BarChart } from "@hedgefund/shared";
import SearchAllocator from "./components/SearchAllocator";
import NewsFeed from "./components/NewsFeed";
import RecentChat from "./components/RecentChat";
import RiskReport from "./components/RiskReport";
import Meetings from "./components/Meetings";
import FundPerformance from "./components/FundPerformance";
import Allocators from "./components/Allocators";
import DashboardCard from "./components/DashboardCard";

import {
  getDashboardAllocators,
  getMyFunds,
  getMeetings,
  getRecentChats,
  getRecentPost,
  getDashboardConfig,
  updateDashboardConfig,
  getStageAllocationCount,
} from "./actions";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Avatar, Progress, Space } from "antd";

const myAllocatorColumns = [
  { name: "Name", key: "name" },
  { name: "Phone", key: "phoneNumber" },
  { name: "AUM", key: "aum" },
];
const fundColumn = [
  { name: "Name", key: "name" },
  { name: "Strategy", key: "strategyTitle" },
  { name: "Monthly Returns", key: "monthlyReturn", toFixed: 2 },
];

// const stageAllocation = [
//   {
//     title: "General Interest",
//     key: 0,
//   },
//   {
//     title: "Introductory Virtual Meeting",
//     key: 1,
//   },
//   {
//     title: "In Depth Meeting",
//     key: 2,
//   },
//   {
//     title: "Due Diligence",
//     key: 3,
//   },
//   {
//     title: "Allocation",
//     key: 4,
//   },
// ];

const weekData = [
  {
    name: "Week",
    id: 7,
  },
  {
    name: "Month",
    id: 30,
  },
];
const MeetingsColumn = [
  { name: "Topic", key: "topic" },
  { name: "Allocator", key: "allocatorName" },
  {
    name: "Date",
    key: "startTime",
    type: "date",
    format: (date) => moment(date).format("DD MMM YYYY"),
  },
  {
    name: "Start Time",
    key: "startTime",
    type: "date",
    format: (date) => moment(date, "hh:mm:ss").format("LT"),
  },
];

const recentChatColumn = [
  {
    name: "Name",
    key: "roomName",
    renderContent: (item) => {
      return (
        <Space size={2}>
          <Avatar src={item.profileImage} /> {item.roomName}
        </Space>
      )
    }
  },
  {
    name: "Message",
    key: "body",
    renderContent: (item) => {
      return (
        <>
          {item.body != null ? item.body?.includes("<style>") ? "Meeting Invitation" : item?.body?.substring(0, 60) + "....." : "File Sent"}
        </>
      )
    }
  },
];

const Dashboard = () => {
  const [dndState, setDndState] = useState(null);
  const dashboardState = useSelector((state) => state.dashboard);
  const dispatch = useDispatch();

  const {
    getAllocators,
    myFundList,
    myMeetings,
    getRecentChat,
    recentPosts,
    dashboardConfigResult,
    getStageAllocation,
  } = dashboardState;
  const { allocatorViews = [], myAllocators = [] } = getAllocators;
  useEffect(() => {
    dispatch(getDashboardConfig(dashboardStatesApis));
  }, [dispatch]);
  useEffect(() => { }, [dispatch]);

  useEffect(() => {
    setDndState(
      dashboardConfigResult.sort((ele1, ele2) => {
        return ele1.orderNo - ele2.orderNo;
      })
    );
  }, [dashboardConfigResult]);

  const allocatorInsigntColumn = [
    {
      name: "Allocator",
      key: "allocatorName"
    },
    {
      name: "Stage",
      key: "stage",
      renderContent: (item) => {
        return (
          <Progress steps={5} className="" percent={StagePercentage(item?.stage)} format={() => ""} />
        )
      }
    },
  ];
  const dashboardStatesApis = () => {
    try {
      dispatch(getDashboardAllocators(7));
      dispatch(getMyFunds());
      dispatch(getMeetings());
      dispatch(getRecentChats());
      dispatch(getRecentPost());
      dispatch(getStageAllocationCount());
    } catch (e) {
      console.log(e);
    }
  };
  const StagePercentage = (stage) => {
    return (stage + 1) * 100 / 5;
  } 
  const updateDashboardConfigClick = () => {
    let payload = dndState.map((config) => {
      return {
        widgetId: config.widgetId,
        // isHide: config.isHide,
        orderNo: config.orderNo,
      };
    });

    dispatch(
      updateDashboardConfig(payload, () => {
        dispatch(getDashboardConfig(dashboardStatesApis));
      })
    );
  };

  const onChangeBarChartData = (e) => {
    dispatch(getDashboardAllocators(e));
  };
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    result.forEach((ele, index) => {
      ele.orderNo = index + 1;
    });

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      dndState,
      result.source.index,
      result.destination.index
    );

    setDndState(items);

    updateDashboardConfigClick();
  };

  const dashboardComponents = {
    1: <SearchAllocator />,

    3: <NewsFeed data={recentPosts}></NewsFeed>,
    4: (
      <RecentChat columns={recentChatColumn} data={getRecentChat}></RecentChat>
    ),

    6: <Meetings columns={MeetingsColumn} data={myMeetings}></Meetings>,
    7: <FundPerformance data={myFundList} columns={fundColumn} />,
    10: (
      <BarChart
        chartData={allocatorViews}
        optionKey={"name"}
        dropDownData={weekData}
        title="Allocator Views"
        onChangeBarChartData={onChangeBarChartData}
      />
    ),
    11: <Allocators columns={myAllocatorColumns} data={myAllocators} />,
    12: <RiskReport fundWatchList={[]} columns={[]} />,
    13: <DashboardCard title={"Allocator Insight"} data={getStageAllocation} columns={allocatorInsigntColumn} />,
  };

  return (
    <main>
      <div className="main-inner">
        <div className="container">
          <div className="row gx-3 gy-3 mt-5">
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    className="row gx-3 gy-3"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {dndState?.map((widget, index) => {
                      return (
                        <Draggable
                          key={index.toString()}
                          draggableId={widget.widgetId.toString()}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              className="col-md-6 col-xl-4"
                              ref={provided.innerRef}
                              snapshot={snapshot}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{ ...provided.draggableProps.style }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  height: "100%",
                                }}
                              >
                                {dashboardComponents[widget.widgetId]}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
